import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { listPaymentMethod as listPaymentMethodHardcode } from "@/constants";
import { PaymentMethod } from "@/types";

const getListPaymentMethod = async () => {
  const response = await api.get("/siswa/plaza/list-payment-method");
  return response.data?.data;
};
export default function usePaymentMethod({
  enable,
}: { enable?: boolean } = {}) {
  const {
    data: listPaymentMethod,
    isPending: isPendingListPaymentMethodPlaza,
  } = useQuery({
    queryKey: ["listPaymentMethod"],
    queryFn: getListPaymentMethod,
    enabled: enable,
  });

  const listPaymentMethodActive =
    listPaymentMethod && listPaymentMethod?.length > 0
      ? listPaymentMethod?.filter((paymentMethod: PaymentMethod) => {
          return paymentMethod?.beta == 0;
        })
      : [];

  const listPaymentMethodPlaza = listPaymentMethodActive.map(
    (active: PaymentMethod) => {
      const hardcode = listPaymentMethodHardcode.find(
        (item) => item.payment_gateway_id === active.id,
      );

      return {
        ...active,
        ...hardcode,
      };
    },
  );

  return { listPaymentMethodPlaza, isPendingListPaymentMethodPlaza };
}
